import styled, { keyframes } from 'styled-components'
import { fadeIn } from 'react-animations'

const fadeInAnimation = keyframes`${fadeIn}`
const FadeInDiv = styled.div`
    animation: ${(props) => (props.duration ? `${props.duration}` : '750ms')} ${fadeInAnimation};
`

const RingInfoSlideUp = styled.div`
    @keyframes slideUp {
        from {
            margin-top: 0;
        }
        to {
            margin-top: -30px;
        }
    }

    animation: slideUp 400ms ease;
    animation-fill-mode: forwards;
`

const RingInfoSlideUpTop = styled.div`
    @keyframes slideUp {
        from {
            margin-top: 0;
        }
        to {
            margin-top: -55px;
        }
    }

    animation: slideUp 400ms ease;
    animation-fill-mode: forwards;
`

export { FadeInDiv, RingInfoSlideUp, RingInfoSlideUpTop }
